import { FC } from "react";
import { Link } from "react-router-dom";
import { clientContent } from "../../client/content";
import { withPage } from "../../components/Page";
import { Hero } from "../../components/Hero";
import { StatCard } from "../../components/StatCard";
import { TaskList } from "../../components/TaskList";
import { RecentItems } from "../../components/RecentItems";
import { NoticeBanner } from "../../components/NoticeBanner";
import { InfoCallout } from "../../components/InfoCallout";
import { ProminentAlert } from "../../components/ProminentAlert";
import styles from "./Home.module.scss";

const Home: FC = () => {
  return (
    <main id="home" className={styles.homeContainer} tabIndex={-1}>
      <div className={styles.headerRow}>
        <div className={styles.headerTextGroup}>
          <span className={styles.eyebrow}>
            {clientContent.siteCode} · {clientContent.tagline.toUpperCase()}
          </span>
          <h1 className={styles.pageTitle}>
            Demo Building Information Platform
          </h1>
          <p className={styles.pageSubtitle}>
            Find trusted building information, quickly and in context.
          </p>
        </div>
        <Link to="/search" className={styles.primaryButton}>
          Search all information
        </Link>
      </div>

      <div className={styles.bannersRow}>
        <NoticeBanner>
          <strong>This is a customisable demo platform:</strong> The structure of
          the app would be customised to fit the data that works for you. It
          demonstrates how Pulse serves as a comprehensive building information
          platform, leveraging advancements in technology such as AI, smarter
          search and optional QR code access — making building information faster
          to find, easier to use and more accessible in the office or on site.
        </NoticeBanner>

        <InfoCallout variant="warning" isHome>
          This is only a demo environment. Many links are illustrative and will do
          nothing.
        </InfoCallout>
      </div>

      <ProminentAlert />

      <Hero />

      <section className={styles.statsGrid} aria-label="Key building metrics">
        <StatCard
          label="Assets"
          value="4,862"
          subtext="124 linked this month"
          trendIcon="↑"
        />
        <StatCard
          label="Drawings"
          value="2,148"
          subtext="96% current revision"
        />
        <StatCard
          label="Documents"
          value="1,074"
          subtext="All disciplines available"
        />
        <StatCard
          label="Last update"
          value="12 Sep 2026"
          subtext="View update log"
          isLink
          linkHref="#update-log"
        />
      </section>

      <section
        className={styles.contentGrid}
        aria-label="Tasks and recent items"
      >
        <TaskList />
        <RecentItems />
      </section>
    </main>
  );
};

const { title, description } = clientContent.seo.home;

export default withPage(Home)({
  meta: {
    title,
    description,
  },
});
